<app-header></app-header>
<!-- <app-banner-enquiry-form></app-banner-enquiry-form> -->
<app-banner-enquiry-form [backgroundImageId]="'2'" [loanTypeId]="13"  serviceName="retirement planning"></app-banner-enquiry-form>>

<!-- Hero Section with Get In Touch Form -->
<!-- <section class="form-section">
 
  <div class="row d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-7">
        <div class="card transparent-card">
            <h1>We help you to Achieve your Financial Goals</h1>
            <a href="/appointment" class="btn btn-orange small-button ">Schedule a Meeting</a>
        </div>
    </div>


    <div class="col-md-5">
      <div class="form-container">
        <h2>GET IN TOUCH</h2>
        <h3 class="slogan">Your journey to financial freedom starts here!</h3>
        <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()">
          <input type="text" formControlName="full_name" placeholder="Enter your Name" required>
          <input type="email" formControlName="email" placeholder="Enter your Email" required>
          <input type="tel" formControlName="phone" placeholder="Enter Phone Number" required>
          <input type="text" formControlName="enq_detail_msg" placeholder="Enter your Message" required>
          <button type="submit" [disabled]="!enquiryForm.valid">Submit</button>
        </form>
      </div>
    </div>
</div>
    

  
</section> -->

<div class="plan-section">
  <h2 class="plan-title">Retirement Planning</h2>
  <p>Retirement planning is a crucial aspect of financial management that involves setting aside funds and creating a strategy to secure a comfortable and stress-free retirement. It is a proactive approach to ensure that individuals can maintain their desired lifestyle even after they stop working.
  </p>
 

  <h3 class="important-heading">
    Why is Retirement Planning Important?
  </h3>
   <div class="underline"></div>
 





  <!-- Setting Financial Goals Section -->
<!-- Retirement Planning Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Retirement Planning is Essential for Many Reasons</h2>
    <p>
      <strong>Financial Independence:</strong> It enables individuals to achieve financial independence, ensuring they have enough savings to maintain their lifestyle without relying on others.
      <br>
      <strong>Peace of Mind:</strong> Having a well-thought-out retirement plan provides peace of mind, knowing that resources are in place to support oneself and family members during retirement.
      <br>
      <strong>Life Expectancy:</strong> With increasing life expectancy, retirement can span several decades, making it essential to have adequate savings and investment strategies in place.
      <br>
      <strong>Inflation and Rising Costs:</strong> Inflation and rising costs can erode purchasing power over time. A retirement plan accounts for these factors, ensuring funds keep up with inflation.
      <br>
      <strong>Healthcare Costs:</strong> Healthcare expenses typically increase with age. A retirement plan includes provisions for healthcare costs, ensuring individuals can afford medical care.
      <br>
      <strong>Legacy Planning:</strong> Retirement planning allows individuals to plan for their legacy, ensuring they can leave behind assets for their heirs or charitable causes.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/rp/25165629_pension_11.jpg" alt="Setting Financial Goals">
  </div>
</section>

  <!-- Developing a Financial Plan Section -->
  <section class="service-section">
    <img src="assets\rp\23746906_pension_5.jpg" alt="Developing a Financial Plan">
    <div class="content">
      <h2>Components of Retirement Planning</h2>
      <p>
        <strong>Setting Goals:</strong> Retirement planning begins with setting clear and achievable goals. These goals include the desired retirement age, lifestyle expectations, travel plans, and legacy goals. <br>
        <strong>Income Sources:</strong> It is crucial to identify sources of income during retirement. These can include pensions, Social Security benefits, investments, and other retirement accounts. <br>
        <strong>Budgeting:</strong>   Creating a budget helps individuals understand their current financial situation and identify areas where they can save or cut expenses to increase retirement savings. <br>
       <strong>Saving and Investing: </strong> Regularly contributing to retirement accounts, NPS, or other tax-advantaged accounts is essential. Investing wisely can help grow retirement savings over time. <br>
      <strong> Insurance:</strong>  Having appropriate insurance coverage, such as health insurance, long-term care insurance, and life insurance, can protect against unexpected expenses during retirement.   </p>
    </div>
  </section>

  <!-- Implementing and Monitoring Your Plan Section -->
  <!-- Conclusion Section -->
<section class="service-section">
  <!-- Text Content -->
  <div class="content order-md-1 order-2">
    <h2>Conclusion</h2>
    <p>
      <strong>Retirement planning</strong> is a critical aspect of financial well-being that requires careful consideration and proactive action. With the help of our expertise, individuals can create a robust retirement plan that aligns with their goals, ensuring a comfortable and secure retirement.
    </p>
  </div>

  <!-- Image -->
  <div class="order-md-2 order-1">
    <img src="assets/Services/fd.svg" alt="Monitoring and Adjusting">
  </div>
</section>

</div>



<section class="contact-us-section">
  <div class="contact-content">
    <h2>Contact Us  Today!</h2>
    <p class="slogan">Your journey to financial freedom starts here!</p>
  </div>

  <div class="contact-form-container"> 
    <form [formGroup]="enquiryForm" (ngSubmit)="onSubmit()" class="contact-form">
      <h2>Submit Your Enquiry</h2>
      <input formControlName="full_name" type="text" placeholder="Your Name" required>
      <input formControlName="email" type="email" placeholder="Your Email" required>
      <input formControlName="phone" type="tel" placeholder="Your Phone Number" required>
      <input type="datetime-local" formControlName="appointment_date" id="appointmentDate" required>
      <textarea formControlName="enq_detail_msg" placeholder="Your Message" required></textarea>
      <button type="submit" [disabled]="enquiryForm.invalid">Send Message</button>
    </form>
  
    <!-- Standard message after submission -->

  <!-- Thank you message with animated smiley -->
  <div *ngIf="isEnquirySubmitted" class="thank-you-message animated">
    <h3>
      Thank you for your enquiry! We will get back to you shortly! 
      <span class="smiley">😊</span>
    </h3>
  </div>
  </div>
  
</section>


<app-footer></app-footer>
